"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileManagerStatus = exports.FileInternalFeatureCode = void 0;
var FileInternalFeatureCode;
(function (FileInternalFeatureCode) {
    FileInternalFeatureCode["JOB"] = "job";
    FileInternalFeatureCode["USER"] = "user";
    FileInternalFeatureCode["LOGS_CONCUR"] = "logs-concur";
    FileInternalFeatureCode["LOGS_OBC"] = "logs-obc";
    FileInternalFeatureCode["LOGS_ROBOTA"] = "logs-robota";
})(FileInternalFeatureCode = exports.FileInternalFeatureCode || (exports.FileInternalFeatureCode = {}));
exports.FileManagerStatus = {
    RAW_NONE: 0,
    RAW_LOADING: 1,
    RAW_LOADED: 2,
    RAW_ERROR: 3,
    SOURCE_NONE: 10,
    SOURCE_LOADING: 11,
    SOURCE_LOADED: 12,
    SOURCE_ERROR: 13,
};
